"use strict";
/* eslint-disable import/prefer-default-export, camelcase */
Object.defineProperty(exports, "__esModule", { value: true });
exports.assessmentsResults = exports.mockUncompletedAssessment = void 0;
exports.mockUncompletedAssessment = {
    assessments: [
        {
            uuid: '5f208a3e-e1c0-41d6-94db-a29febed3c8e',
            name: 'QA Asessment JAVA',
            url: '',
            categories: [
                'Broken Authentication and Session Management',
                'Sensitive Data Exposure',
                'Cross Site Request Forgery',
                'Broken Access Control',
                'Unvalidated Redirects and Forwards',
            ],
            start_date: new Date(),
            end_date: new Date(),
            is_started: false,
        },
        {
            uuid: '5f208a3e-e1c0-41d6-94db-a29febed3c8e',
            name: 'QA Asessment JAVA',
            url: '',
            categories: ['Category 1', 'Same site data expose by scool home work', 'injection', 'Category 4'],
            start_date: new Date(),
            end_date: new Date(),
            is_started: true,
        },
    ],
};
exports.assessmentsResults = {
    overall_statistics: {
        total_completed_assessments: 3,
        average_rating: 72,
        categories: {
            strong: [],
            fair: [],
            poor: [],
        },
    },
    assessments_breakdown: [
        {
            uuid: 'c4f02aa0-cdd0-4bee-b6fc-6e4bc875e959',
            name: '2023 Assessment',
            rating: 75,
            total_questions: 4,
            correct_answers: 3,
            start_date: '2023-03-01',
            end_date: '2023-05-31',
            answers_breakdown: [
                {
                    category: 'Injection',
                    vulnerability: 'SQL Injection',
                    is_correct: true,
                },
            ],
        },
    ],
};
